import React, { useState } from 'react'
import { FormikProps } from 'formik'
import { usePayflowPro } from 'lib/core/hooks'
import { Toast } from 'lib/ui'
import {
  useCheckout,
  usePaymentMethod,
  CreditCardForm,
  CreditCardData,
  CreditCardFormValues
} from 'lib/modules/checkout'

import { Container } from './styled'

let values: CreditCardData
let formik: FormikProps<CreditCardFormValues>

export const PayflowPro = () => {
  const { placeOrder } = useCheckout()
  const { fetchPayflowProToken, PayflowProIframe } = usePayflowPro()
  const [tokens, setTokens] = useState<undefined | any>()

  usePaymentMethod(() => {
    formik.handleSubmit()
    formik.validateForm().then((errors) => {
      const hasErrors = !!Object.keys(errors).length
      if (!hasErrors) {
        const ccData = {
          ...values,
          saveCard: false
        }
        fetchPayflowProToken({ ccData }).then(payflowProTokens => {
          if (payflowProTokens) {
            setTokens(payflowProTokens)
          }
        }).catch(() => {
          Toast.toastFailure()
          // TODO: report err
        })
      }
    })
  })

  const handleChange = (formValues: CreditCardData, formikObject: FormikProps<CreditCardFormValues>) => {
    values = formValues
    formik = formikObject
  }

  return (
    <Container>
      <CreditCardForm
        onChange={handleChange}
      />

      <PayflowProIframe
        ccData={values}
        tokens={tokens}
        onSuccess={() => {
          placeOrder()
        }}
        onError={(message) => {
          Toast.toastFailure(message ? { messageId: message } : undefined)
        }}
      />
    </Container>
  )
}
